module.exports = {
    PAINEL: { code: 1, description: 'Gerado no Painel' },
    APP: { code: 2, description: 'Gerado no App' },
    CONFLICT: { code: 3, description: 'Conflito entre APP e Painel' },
}
